import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <span className="letter c">©</span>
        <span className="letter space"></span>
        <span className="letter year-2">2</span>
        <span className="letter year-0">0</span>
        <span className="letter year-2">2</span>
        <span className="letter year-4">4</span>
        <span className="letter space"></span>
        <span className="letter l">L</span>
        <span className="letter i">i</span>
        <span className="letter p">p</span>
        <span className="letter o">o</span>
        <span className="letter s">S</span>
        <span className="letter t">t</span>
        <span className="letter y">y</span>
        <span className="letter l-2">l</span>
        <span className="letter e">e</span>
        <span className="letter e-2">e</span>
        <span className="letter space"></span>
        <span className="letter c">©</span>
      </div>
    </footer>
  );
};

export default Footer;
